module.exports = __webpack_public_path__ + "static/media/P20-Plunger.3127b89e.svg";